import { useMutation } from "react-query";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { HelpWidgetConversation } from "../types/help_widget_conversation";

export const useUpdateConversation = () =>
  useMutation({
    mutationFn: ({
      id,
      conversation,
    }: {
      id: string;
      conversation: HelpWidgetConversation;
    }) =>
      reactQueryPatch(
        internalApi.helpWidget.updateConversation({
          id,
          conversation,
        }),
      ),
  });
